module.exports = __webpack_public_path__ + "img/logocentral.69c1272f.png";